import React from 'react';
import Dftj from '../Components/Dftj';
import Faq from '../Components/faq';
import WhyChoose from '../Components/WhyChoose';
import AboutHero from '../Components/AboutHero.';
// import Moum from '../Components/Moum';
import StoryVision from '../Components/StoryVision';

const About: React.FC = () => {
  return (
    <section>
      {/* About Hero */}
      <AboutHero />
      <StoryVision />
      <WhyChoose />
      {/* Meet our unique mind */}
      {/*<Moum />*/}
      <Faq />
      <Dftj />
    </section>
  );
};

export default About;
